import useGlobalStore from 'hooks/useGlobalStore';
import twclsx from 'utils/twclsx';

/**
 * Displays a message about waiving the order minimum with SNAP EBT payment.
 *
 * If the Pay with EBT button is enabled, renders the message with an anchor link
 * that should trigger the EBT payment modal (to be implemented).
 *
 * @param {Object} props - The component props.
 * @param {string} [props.className=''] - Additional classes to apply to the component.
 * @param {boolean} [props.enabledPayWithEBTButton=false] - Determines if the "Pay with SNAP EBT" button is enabled (renders as a clickable link). Defaults to false.
 * @returns {JSX.Element} The EBT order minimum waiver message.
 */

function EBTOrderMinMessage({ className = '', enabledPayWithEBTButton = false }) {
    const { setEbtPaymentFlowOpen } = useGlobalStore();
    return (
        <span className={twclsx('text-body-sm block', className)}>
            {enabledPayWithEBTButton ? (
                <button className="underline" onClick={() => setEbtPaymentFlowOpen(true)} type="button">
                    Pay with SNAP EBT
                </button>
            ) : (
                'Pay with SNAP EBT'
            )}{' '}
            to waive the order minimum.
        </span>
    );
}

export default EBTOrderMinMessage;
